import React from "react";

const SearchResultSquirrel = ({ item, close }) => {
	return <></>;
};

export default SearchResultSquirrel;
